import { compact } from '~/utils/helpers'

const usePlpHook = ({ collection }) => {
  
  const checkFilterParams = ({ setCurrGrpId, onFilter, locate, setLocate }) => {
    const allFilters = collection.allFilters

    const url = new URL(window.location.href)
    url.searchParams.forEach((v,k) => {
      if (k.includes('utm_')) return
      const arr = decodeURIComponent(v).split(',')
      arr.forEach(x => { if ( allFilters[k] && allFilters[k].includes(x) ) onFilter({type: k, name: x}) })
      if (k === 'gt') {
        let gid = collection.groups.find(x => x.data.name.toLowerCase().replaceAll("'",'') === v.toLowerCase())
        if (gid) setCurrGrpId(gid.mid)
      }
      if (k === 'groupfeature' && collection.feature_bubb && collection.feature_bubb.length) {
        let gid =  collection.feature_bubb.find(x => x.toLowerCase().replaceAll("'",'') === v.toLowerCase())
        onFilter({type: 'groupfeature',name: gid})
      }
      if (k === 'locations') {
        setLocate({
          ...locate,
          currStores: [arr[0]]
        })
      }
    })
  }

  const checkFeatParams = ({ setFeatIds }) => {
    const url = new URL(window.location.href)
    let featids = false
    url.searchParams.forEach((v,k) => {
      if (k.includes('utm_')) return
      let arr = decodeURIComponent(v).split(',')
      if (k === 'f') {
        const ids = arr.map(x => parseInt(x)).filter(x => !!x)
        if (ids.length > 0) featids = ids
      }
    })
    if (!featids || featids?.length < 1) return

    let all_ids = collection.products.map(x => x?.mid)
    all_ids = compact(all_ids.concat(collection.prods_pk.map(x => x?.mid)) )
    featids = featids.filter(x => all_ids.includes(x))
    if (featids?.length > 0) setFeatIds(featids)
  }
  
  const afterFilterParams = ({ filters, currSort, currGrpId, featIds, getGroupName, upd_params }) => {
    const any_filt = filters.length > 0 || currSort || currGrpId

    if (any_filt) scrollProdsTop()
    if (!featIds) {
      upd_params(filters, getGroupName(currGrpId))
    }
    if (!any_filt && featIds) {
      upd_params([{type: 'f', name: featIds.join(',')}], getGroupName(currGrpId))
    }
    const url = new URL(window.location.href)
    const has_groupt = url.searchParams.get('gt')

    if (!currGrpId && has_groupt) {
      url.searchParams.delete('gt')
      window.history.replaceState(null, null, url.toString())
      const breadpath = url.toString().replace(url.origin, '')
      sessionStorage.setItem('fbread',breadpath)
    }
  }

  const scrollProdsTop = () => {
    const head_el = document.querySelector('[plp-head]')
    let head_b = 0
    if (head_el) {
      head_b = head_el.offsetTop + head_el.getBoundingClientRect().height + 20
    }
    const gnav_el = document.querySelector('[gnav]')
    let gnav_b = 0
    if (gnav_el) {
      gnav_b = gnav_el.offsetTop + gnav_el.getBoundingClientRect().height + 20
    }
    let newpos = 0
    const bar_el = document.querySelector('[plp-bar]')
    const bar_h = bar_el ? bar_el.getBoundingClientRect().height : 0

    newpos = gnav_el ? (gnav_b - bar_h) : (head_b - bar_h)

    window.scrollTo({
      top: newpos,
      behavior: 'smooth'
    })
  }

  const checkStoreGend = ({ locate }) => {
    if (!locate) return false
    let check = false
    if (locate?.currStores?.length > 0 && collection.gender !== 'u' && !!locate?.storeGend) {
      if (collection.gender !== locate.storeGend) check = true
    }
    return check
  }

  const anaProducts = (products) => {
    const cleaned = products.filter(x => !!x)
    let prodsarr
    if (cleaned.find(x => x.hasOwnProperty('products'))) {
      prodsarr = cleaned.map(x => {
        return x.hasOwnProperty('products') ? x.products : x
      })
      prodsarr = prodsarr.flat()
    } else {
      prodsarr = cleaned
    }
    prodsarr = prodsarr.filter(x => !!x && x.hasOwnProperty('filters'))

    return prodsarr
  }


  return { checkFilterParams, checkFeatParams, checkStoreGend, afterFilterParams, scrollProdsTop, anaProducts }
}


export default usePlpHook

